// extracted by mini-css-extract-plugin
export default {"buttons":"Footer_buttons__s44YJ"};